import { GridRenderEditCellParams } from '@mui/x-data-grid';

import { TargetAttributeDto, TargetAttributeDtoType } from '@/generated/model';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

export default function TypeBasedDisplay({ params }: { params: GridRenderEditCellParams }) {
  const { isEditable, row } = params;
  const { t } = useTranslation();
  if (!isEditable) {
    // These are the value columns next to tag counters
    return;
  }
  return <span className="target-attribute-value">{getContent(row, t)}</span>;
}

function getContent(targetAttribute: TargetAttributeDto, t: TFunction<'translation', undefined>) {
  if (!targetAttribute.value && targetAttribute.various) {
    return <>{t('targetAttributes.variousValues')}</>;
  }

  // 0 is valid value
  const attributeValue = targetAttribute.value;
  if (!attributeValue && attributeValue !== 0) {
    return <div className="empty-target-attribute"></div>;
  }

  switch (targetAttribute.type) {
    case TargetAttributeDtoType['@class']:
      return (
        <>
          {attributeValue.brand} {attributeValue.type}
        </>
      );
    case TargetAttributeDtoType['@list']:
      return <>{attributeValue.translation}</>;
    default:
      return <>{attributeValue}</>;
  }
}
